import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-easy',
  templateUrl: './icon-easy.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEasyComponent {}
